function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* script */
//
//
//
//
//
//
//
//
//
//
import { formatDate, isAllowedDate } from '../utils';
var __vue_script__ = {
  name: 'TodayButton',
  props: {
    prefixCls: String,
    locale: Object,
    disabledDate: Function,
    disabled: Boolean,
    format: String,
    text: String,
    isShowOk: Boolean,
    hasTimePicker: Boolean
  },
  computed: {
    content: function () {
      var text = this.text,
          hasTimePicker = this.hasTimePicker,
          locale = this.locale,
          isShowOk = this.isShowOk;
      var content = '';

      if (text) {
        content = text;
      } else if (hasTimePicker || isShowOk) {
        content = locale.now;
      } else {
        content = locale.today;
      }

      return content;
    },
    today: function today() {
      return new Date();
    },
    classes: function classes() {
      var _ref;

      var prefixCls = this.prefixCls,
          disabled = this.disabled,
          disabledDate = this.disabledDate,
          today = this.today;
      return _ref = {}, _defineProperty(_ref, "".concat(prefixCls, "-today-btn"), true), _defineProperty(_ref, "".concat(prefixCls, "-today-btn-disabled"), disabledDate && !isAllowedDate(today, disabledDate) || disabled), _ref;
    },
    todayStr: function todayStr() {
      return formatDate(this.today, this.format, {
        locale: this.locale.DateFnsLocale
      });
    }
  },
  methods: {
    onClick: function onClick() {
      if (this.disabled) {
        return;
      }

      this.$emit('on-click');
    }
  }
};
/* template */

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('a', {
    class: _vm.classes,
    attrs: {
      "role": "button",
      "title": _vm.todayStr
    },
    on: {
      "click": _vm.onClick
    }
  }, [_vm._v("\n  " + _vm._s(_vm.content) + "\n")]);
};

var __vue_staticRenderFns__ = [];
/* style */

var __vue_inject_styles__ = undefined;
/* scoped */

var __vue_scope_id__ = undefined;
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* component normalizer */

function __vue_normalize__(template, style, script, scope, functional) {
  var component = (typeof script === 'function' ? script.options : script) || {}; // For security concerns, we use only base name in production mode.

  component.__file = "todayButton.js";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;
  return component;
}
/* style inject */

/* style inject SSR */


export default __vue_normalize__({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, undefined, undefined);